export default "__VITE_ASSET__32e67657__"